import {
  BaSeCheckbox,
  BaSeHeading5,
  BaSeParagraph,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import { FormContext } from '../../hook/form-context';
import { InterestButton } from './style';

const EMPRETEC_RURAL_ID = 4;

const MESSAGES = {
  otherPeriod: {
    title: 'Nenhuma dessas datas te atendem?',
    contact: 'Entraremos em contato quando novos seminários forem abertos.',
  },
  noClasses: {
    title: 'Ainda não há seminários disponíveis para sua região.',
    contact:
      'Entraremos em contato assim que surgir um novo seminário na sua localidade.',
  },
};

function RegisterInterest({ type }) {
  const {
    empretecId,
    selectedIdClass,
    interestWithoutClass,
    setInterestWithoutClass,
  } = React.useContext(FormContext);

  const { title, contact } = MESSAGES[type];

  const register =
    empretecId === EMPRETEC_RURAL_ID
      ? 'Registre seu interesse.'
      : 'Registre seu interesse e faça sua entrevista de seleção.';

  return (
    <div style={{ marginTop: 24 }}>
      <BaSeHeading5 isBold color={BaSeTheme.colors.defaultColors.white}>
        {title}
      </BaSeHeading5>
      <BaSeParagraph color={BaSeTheme.colors.defaultColors.white}>
        {register} <br /> {contact}
      </BaSeParagraph>

      <InterestButton
        type="button"
        disabled={!!selectedIdClass}
        onClick={() => setInterestWithoutClass((prev) => !prev)}
      >
        <BaSeCheckbox
          checked={interestWithoutClass}
          disabled={!!selectedIdClass}
          onChange={() => { }}
        />
        <BaSeParagraph
          isBold
          color={BaSeTheme.colors.institucionais.azulSebrae}
        >
          Tenho interesse
        </BaSeParagraph>
      </InterestButton>
    </div>
  );
}

export default RegisterInterest;
